import { render, staticRenderFns } from "./Print_Restaurant_Style_5.vue?vue&type=template&id=4f4bd78c&"
import script from "./Print_Restaurant_Style_5.vue?vue&type=script&lang=js&"
export * from "./Print_Restaurant_Style_5.vue?vue&type=script&lang=js&"
import style0 from "./Print_Restaurant_Style_5.vue?vue&type=style&index=0&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports